import {AdminPagingModel} from "./AdminPagingModel";
import {SensorStat} from "../../entities/SensorStatsHistory";
import {SensorStatService} from "../../services/SensorStatService";
import {NotificationService} from "../../services/NotificationService";
import {GridBookmarkService} from "../../services/GridBookmarkService";

export class SensorStatAdminPagingModel extends AdminPagingModel<SensorStat>{
        static $inject = ['$q','SensorStatService','NotificationService','GridBookmarkService'];
        constructor($q:ng.IQService, pagingService:SensorStatService,notificationService:NotificationService,
                    gridBookmarkService:GridBookmarkService){
            super($q, pagingService,notificationService,gridBookmarkService);
        }
        getCustomActions():string[]{
            return [];
        }
        entityName():string{
            return "sensorstat";
        }
        displayName():string{
            return "V-Tag Sensors Stats";
        }
        addEditAllowed():boolean{
          return false;
        }
        deleteAllowed():boolean{
          return false;
        }
        transformItem(entity:SensorStat){
        }
        getColumnDefs():ng.IPromise<void>{
            this.nameValuePairs =
                [
                    ['created', 'Created', 200],
                    ['vTagID', 'VTag ID', 120],
                    ['assetName', 'Asset Name', 130],
                    ['sourceDistanceHops', 'Source Distance Hops', 250],
                    ['ttl', 'TTL', 90],
                    ['numNeighbors', 'Num Neighbors', 310],
                    ['numActiveNeighbors', 'Num Active Neighbors', 135],
                    ['totalErrors', 'Total Errors', 150],
                    ['lastError', 'Last Error', 145],
                    ['bestNeighbor', 'Best Neighbor', 145],
                    ['bestNeighborRssiDbm', 'Best Neighbor Rssi Dbm', 145],
                    ['minQueue', 'Min Queue', 145],
                    ['maxQueue', 'Max Queue', 145],
                    ['avgQueue', 'Avg Queue', 145],
                    ['processedPackets', 'Processed Packets', 145],
                    ['alarmCount', 'Alarm Count', 145],
                    ['firmwareVersion', 'Firmware Version', 145],
                    ['movementTriggers', 'Movement Triggers', 145],
                    ['suspectTriggers', 'Suspect Triggers', 145],
                    ['daysSinceReset', 'Days Since Reset', 145],
                    ['leafDroppedPackets', 'Leaf Dropped Packets', 145]
                ];
            return this.$q.when();
        }
    }
